<h3 class="panel-title">{{ termKey.ActivityServicePlural | term }}</h3>
@if (service.serviceActivities.length) {
  <table
    mat-table
    [dataSource]="
      service.serviceActivities
        | paginate
          : {
              id: 'activities-' + service.id,
              itemsPerPage: activitiesLimit,
              currentPage: activityPage,
              totalItems: service.serviceActivities.length,
            }
    "
  >
    <ng-container matColumnDef="acciones">
      <th mat-header-cell *matHeaderCellDef></th>
      <td mat-cell *matCellDef="let activity">
        <a mat-icon-a [matMenuTriggerFor]="activityMenu" aria-label="Acciones" title="Acciones">
          <mat-icon class="main-icon">menu</mat-icon>
        </a>
        <mat-menu #activityMenu="matMenu" class="icon-menu">
          <button mat-menu-item class="icon-button" (click)="updateActivity(activity)">
            <span class="text-span"
              ><mat-icon class="icon-size">edit</mat-icon> Editar
              {{ termKey.ActivityServiceSingular | term }}</span
            >
          </button>
          <button mat-menu-item class="icon-button" (click)="openInsumosDialog(activity.id)">
            <span class="text-span"
              ><mat-icon class="icon-size">shopping_cart</mat-icon> Asignar insumos</span
            >
          </button>
          <mat-divider></mat-divider>
          <button mat-menu-item class="icon-button" (click)="deleteActivity(activity)">
            <span class="text-span delete-span"
              ><mat-icon class="icon-size delete-icon">delete</mat-icon> Eliminar
              {{ termKey.ActivityServiceSingular | term }}</span
            >
          </button>
        </mat-menu>
      </td>
    </ng-container>

    <ng-container matColumnDef="id">
      <th mat-header-cell *matHeaderCellDef>ID</th>
      <td mat-cell *matCellDef="let serviceactivity">
        {{ serviceactivity.id }}
      </td>
    </ng-container>

    <ng-container matColumnDef="name">
      <th mat-header-cell *matHeaderCellDef>Nombre</th>
      <td mat-cell *matCellDef="let serviceactivity">
        {{ serviceactivity.name }}
      </td>
    </ng-container>

    <ng-container matColumnDef="description">
      <th mat-header-cell *matHeaderCellDef>Descripción</th>
      <td mat-cell *matCellDef="let serviceactivity">
        {{ serviceactivity.description }}
      </td>
    </ng-container>

    <ng-container matColumnDef="month">
      <th mat-header-cell *matHeaderCellDef>Mes</th>
      <td mat-cell *matCellDef="let serviceactivity">
        {{ serviceactivity.month }}
      </td>
    </ng-container>

    <ng-container matColumnDef="consumableAssets">
      <th mat-header-cell *matHeaderCellDef>Insumos</th>

      <td mat-cell *matCellDef="let serviceactivity">
        @if (serviceactivity.consumableAssets?.length) {
          <ul class="m-0 ps-3">
            @for (asset of serviceactivity.consumableAssets; track asset.id) {
              @for (ca of asset.consumableAsset; track ca.id) {
                <li>
                  {{ ca.name }}
                  ({{ asset.expense?.qty }} {{ asset.expense?.unity }})
                </li>
              }
            }
          </ul>
        } @else {
          <span>No registra</span>
        }
      </td>
    </ng-container>

    <ng-container matColumnDef="locations">
      <th mat-header-cell *matHeaderCellDef>Ubicación</th>

      <td mat-cell *matCellDef="let serviceactivity">
        @if (serviceactivity.locations?.length) {
          <ul>
            @for (lo of serviceactivity.locations; track lo) {
              <li>{{ lo.city }} - {{ lo.department }}</li>
            }
          </ul>
        } @else {
          <span>No registra</span>
        }
      </td>
    </ng-container>

    <ng-container matColumnDef="adress">
      <th mat-header-cell *matHeaderCellDef>Dirección</th>
      <td mat-cell *matCellDef="let serviceactivity">
        {{ serviceactivity.adress?.street }}
      </td>
    </ng-container>

    <ng-container matColumnDef="line">
      <th mat-header-cell *matHeaderCellDef>Línea</th>
      <td mat-cell *matCellDef="let serviceactivity">
        {{ serviceactivity.line?.name }}
      </td>
    </ng-container>

    <ng-container matColumnDef="total">
      <th mat-header-cell *matHeaderCellDef>Total</th>
      <td mat-cell *matCellDef="let serviceactivity">
        {{ serviceactivity.total }}
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="activityColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: activityColumns"></tr>
  </table>
  @if (service.serviceActivities.length > activitiesLimit) {
    <pagination-controls
      [id]="'activities-' + service.id"
      (pageChange)="activityPage = $event"
      previousLabel="Anterior"
      nextLabel="Siguiente"
    ></pagination-controls>
  }
} @else {
  <p class="empty-label">No registra actividades.</p>
}
